import { useTranslation } from 'react-i18next'
import { PlanType, ServerLanguages, useBootstrapBusinessAnonymously } from '@expane/data'
import { DEFAULT_TIMEZONE } from '@expane/date'
import { useState } from 'react'

interface UserCredential {
  user: { getIdToken(forceRefresh?: boolean): Promise<string> }
}

export const useCreateBusinessAnonymously = ({
  signInAnonymously,
  onSuccess,
  onError,
  getLeadId,
}: {
  signInAnonymously: () => Promise<UserCredential | undefined>
  onError: (e?: unknown) => void
  onSuccess: (dto: {
    branchId: number
    businessId: number
    email?: string | null
    employeeId: number
  }) => void
  // Актуально тільки для WEB
  getLeadId?: () => string | null
}) => {
  const {
    i18n: { language },
  } = useTranslation()

  const [isLoading, setIsLoading] = useState(false)

  const { mutateAsync: bootstrapBusinessAnonymously } = useBootstrapBusinessAnonymously()

  const createBusinessAnonymously = async () => {
    setIsLoading(true)

    try {
      const leadId = getLeadId?.()

      const userCredential = await signInAnonymously()
      const token = await userCredential?.user?.getIdToken(true)

      if (!token) {
        onError(new Error('Error on signInAnonymously. Token is not provided'))

        return
      }

      const result = await bootstrapBusinessAnonymously({
        token,
        lang: language as ServerLanguages,
        timezone: DEFAULT_TIMEZONE,
        leadId,
        // TODO: вибір плану та модулів згідно опитування
        // Там же можна буде передавати кількість клієнтів та співробітників
        planType: PlanType.Professional,
        modulesSettings: {
          branches: false,
          checkbox: false,
          consumables: false,
          giftCards: true,
          managingEmployee: false,
          payment: false,
          productsForSale: false,
          servicesForSale: false,
          subscriptions: true,
        },
      })

      if (
        result.createBusinessAnonymously?.businessId &&
        result.createBusinessAnonymously?.branchId &&
        result.createBusinessAnonymously?.employeeId
      ) {
        onSuccess({
          businessId: result.createBusinessAnonymously.businessId,
          branchId: result.createBusinessAnonymously.branchId,
          employeeId: result.createBusinessAnonymously.employeeId,
          email: result.createBusinessAnonymously.email,
        })
      } else {
        onError(new Error('Error on bootstrapBusinessAnonymously. Result is not provided'))
      }
    } catch (e) {
      onError(e)
    } finally {
      setIsLoading(false)
    }
  }

  return { createBusinessAnonymously, isLoading }
}
